import React, { Component } from "react";
import "./Dropzone.css";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { acceptedFileTypes } from "../uploadHelper";

class Dropzone extends Component {
  constructor(props) {
    super(props);
    this.state = { hightlight: false };
    this.fileInputRef = React.createRef();

    this.openFileDialog = this.openFileDialog.bind(this);
    this.onFilesAdded = this.onFilesAdded.bind(this);
    this.onDragOver = this.onDragOver.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDrop = this.onDrop.bind(this);
    }

  openFileDialog() {
    if (this.props.disabled) return;
    this.fileInputRef.current.click();
  }

  onFilesAdded(evt) {
    if (this.props.disabled) return;
      let files = evt.target.files;
    if (this.props.onFilesAdded) {
        let array = this.fileListToArray(files);
        array = array.filter(x => acceptedFileTypes.includes(x.type));
        this.props.onFilesAdded(array);
    }
  }

  onDragOver(event) {
    event.preventDefault();
    if (this.props.disabed) return;
    this.setState({ hightlight: true });
  }

  onDragLeave(event) {
    this.setState({ hightlight: false });
  }

  onDrop(event) {
    event.preventDefault();
    if (this.props.disabed) return;
    const files = event.dataTransfer.files;
    if (this.props.onFilesAdded) {
      const array = this.fileListToArray(files);
      this.props.onFilesAdded(array);
    }
    this.setState({ hightlight: false });
  }

  fileListToArray(list) {
    const array = [];
    for (var i = 0; i < list.length; i++) {
      array.push(list.item(i));
    }
    return array;
  }

  render() {
    return (
      <div
        className={`Dropzone ${this.state.hightlight ? "Highlight" : ""}`}
        onDragOver={this.onDragOver}
        onDragLeave={this.onDragLeave}
        onDrop={this.onDrop}
        onClick={this.openFileDialog}
        style={{ cursor: this.props.disabled ? "default" : "pointer" }}
      >
            <input
          id='fileInput'
          ref={this.fileInputRef}
          className="FileInput"
          type="file"
          multiple
          onChange={this.onFilesAdded}
          accept=".doc,.docx,.tif,.tiff,.pdf,.rtf"

        />
            <CloudUploadIcon style={{fontSize: 64, color: 'rgb(187, 186, 186)'} } />
            <span>{this.props.caption || "Upload Files"}</span>
      </div>
    );
  }
}

export default Dropzone;



// WEBPACK FOOTER //
// ./src/components/Common/CommonUpload/dropzone/Dropzone.js